export var VELT_SDK_VERSION = '5.0.2-beta.30';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '5.0.2-beta.30': 'sha384-1k3G99Dpmh/qSLUgLJMRqIAUILI8vILR15uOH6fvGcXQXVBNcJmie1aBGyH6YWeC',
};
